import { Box, Container, Typography, Chip, Stack } from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { DashboardMockup } from "./mockup";

const TRUST = [
  "Real-time insights",
  "No credit card required",
  "Setup in minutes",
];

function Hero() {
  return (
    <Box
      id="top"
      component="section"
      sx={{
        position: "relative",
        pt: { xs: 14, md: 18 },
        pb: { xs: 10, md: 14 },
        overflow: "hidden",

        background:
          "linear-gradient(180deg, #f8fafc 0%, #eef6ff 45%, #f8fafc 100%)",
      }}
    >
      <Box aria-hidden sx={{ position: "absolute", inset: 0 }}>
        <Box
          sx={{
            position: "absolute",
            top: -260,
            left: -220,
            width: 700,
            height: 700,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(59,130,246,0.30), transparent 65%)",
            filter: "blur(100px)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: -220,
            right: -240,
            width: 650,
            height: 650,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(14,165,233,0.25), transparent 65%)",
            filter: "blur(110px)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: "20%",
            left: "50%",
            transform: "translateX(-50%)",
            width: 900,
            height: 900,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(37,99,235,0.18), transparent 70%)",
            filter: "blur(120px)",
          }}
        />
      </Box>

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ textAlign: "center", maxWidth: 920, mx: "auto" }}>
          <Chip
            icon={<AutoAwesomeRoundedIcon sx={{ fontSize: 16 }} />}
            label="Streamline Inventory • Manufacturing • Revenue"
            sx={{
              mb: 3,
              px: 1.5,
              py: 2,
              fontWeight: 600,
              fontSize: "0.85rem",
              letterSpacing: "0.3px",

              bgcolor: "rgba(255,255,255,0.7)",
              backdropFilter: "blur(14px)",
              border: "1px solid rgba(59,130,246,0.25)",
              color: "#1e3a8a",
              borderRadius: 999,

              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 10px 30px rgba(37,99,235,0.15)",
              },
            }}
          />

          <Typography
            sx={{
              fontSize: { xs: "2.6rem", sm: "3.8rem", md: "4.8rem" },
              fontWeight: 900,
              lineHeight: 1.05,
              letterSpacing: "-0.04em",
              mb: 2,
              color: "#0f172a",
            }}
          >
            Run your entire business from{" "}
            <Box
              component="span"
              sx={{
                background:
                  "linear-gradient(120deg, #2563eb 0%, #0ea5e9 50%, #38bdf8 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              one dashboard
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "#475569",
              maxWidth: 720,
              mx: "auto",
              mb: 4,
              fontSize: { xs: "1rem", md: "1.25rem" },
              lineHeight: 1.7,
            }}
          >
            FlowSync helps businesses track products, manage manufacturing workflows,
            and monitor revenue with real-time operational insights.
          </Typography>

          <Stack
            direction="row"
            spacing={1.2}
            sx={{
              justifyContent: "center",
              flexWrap: "wrap",
              mb: 7,
            }}
          >
            {TRUST.map((t) => (
              <Chip
                key={t}
                label={t}
                size="small"
                sx={{
                  bgcolor: "rgba(255,255,255,0.85)",
                  border: "1px solid rgba(59,130,246,0.18)",
                  color: "#334155",
                  backdropFilter: "blur(12px)",
                  borderRadius: 999,

                  transition: "all 0.25s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  },
                }}
              />
            ))}
          </Stack>
        </Box>

        <Box
          sx={{
            maxWidth: 1150,
            mx: "auto",
            borderRadius: 5,
            overflow: "hidden",
            background:
              "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
            border: "1px solid rgba(226,232,240,0.9)",
            boxShadow: "0 50px 120px rgba(0,0,0,0.18)",

            transition: "all 0.4s ease",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 60px 140px rgba(0,0,0,0.22)",
            },
          }}
        >
          <DashboardMockup />
        </Box>
      </Container>
    </Box>
  );
}

export default Hero;